import Auth from "../Auth";

/**
 * Collects active + entity project ids that may each hold stale Story Bible summary caches.
 * @param {Array<{ projectId?: string }>} entities
 * @param {string} activeProjectId
 */
export function storyBibleCacheProjectIdsForEntities(entities, activeProjectId) {
  const projectIds = new Set([activeProjectId].filter(Boolean));
  entities.forEach((entity) => {
    if (entity?.projectId) projectIds.add(entity.projectId);
  });
  return [...projectIds];
}

/**
 * Batch-invalidates Story Bible LLM summary caches after bulk character/worldbuilding saves.
 * @param {string | string[]} projectIds
 * @param {Array<"characters" | "worldbuilding">} [scopes]
 */
export async function invalidateStoryBibleSummaryCaches(projectIds, scopes) {
  const ids = [...new Set((Array.isArray(projectIds) ? projectIds : [projectIds]).filter(Boolean))];
  if (!ids.length) return;
  await Promise.all(
    ids.map((projectId) =>
      Auth.fetchWithIdToken("/api/story-bible/invalidate-summary-caches", {
        projectId,
        ...(scopes?.length ? { scopes } : {}),
      }),
    ),
  );
}
